// `_functions` : an object's function
// ------------------------------------

// The cornerstone, a `functions` implementation, aka `methods`.
export {default} from './methods';